// Mock speaking-attempt feedback for the /student feedback view. The attempts
// mirror the teacher mockup's Speaking review data (teacher/page/LessonPageData.ts)
// so both mockups show the same recordings from each side.

import { CharacterGrade } from './mockLessonContent';

export interface SpeakingAttemptFeedback {
    id: string;
    lessonName: string;
    exerciseLabel: string;
    submitted: string;
    promptEnglish: string;
    sentenceHanzi: string;
    sentencePinyin: string;
    aiScore: number;
    aiFeedback: string;
    grades: CharacterGrade[];
    review?: { teacherScore: number; comment: string; reviewedOn: string };
}

export const mockFeedbackAttempts: SpeakingAttemptFeedback[] = [
    {
        id: 'fb-order',
        lessonName: 'Lesson 4: Ordering at a Restaurant',
        exerciseLabel: 'Guided ordering practice',
        submitted: 'Yesterday, 4:12 PM',
        promptEnglish: 'Ask the server for one plate of dumplings and a cup of tea.',
        sentenceHanzi: '请给我一盘饺子和一杯茶。',
        sentencePinyin: 'Qǐng gěi wǒ yì pán jiǎozi hé yì bēi chá.',
        aiScore: 78,
        aiFeedback: 'Clear overall. The tone on 盘 was uncertain, and 茶 was slightly shortened.',
        grades: [
            { character: '请', pinyinExpected: 'qǐng', pinyinSpoken: 'qǐng', initial: 'good', final: 'good', tone: 'good' },
            { character: '给', pinyinExpected: 'gěi', pinyinSpoken: 'gěi', initial: 'good', final: 'good', tone: 'good' },
            { character: '我', pinyinExpected: 'wǒ', pinyinSpoken: 'wǒ', initial: 'good', final: 'good', tone: 'good' },
            { character: '一', pinyinExpected: 'yì', pinyinSpoken: 'yì', initial: 'good', final: 'good', tone: 'good' },
            { character: '盘', pinyinExpected: 'pán', pinyinSpoken: 'pán', initial: 'good', final: 'good', tone: 'ok' },
            { character: '饺', pinyinExpected: 'jiǎo', pinyinSpoken: 'jiǎo', initial: 'good', final: 'good', tone: 'good' },
            { character: '子', pinyinExpected: 'zi', pinyinSpoken: 'zi', initial: 'good', final: 'good', tone: 'good' },
            { character: '和', pinyinExpected: 'hé', pinyinSpoken: 'hé', initial: 'good', final: 'good', tone: 'good' },
            { character: '一', pinyinExpected: 'yì', pinyinSpoken: 'yì', initial: 'good', final: 'good', tone: 'good' },
            { character: '杯', pinyinExpected: 'bēi', pinyinSpoken: 'bēi', initial: 'good', final: 'good', tone: 'good' },
            { character: '茶', pinyinExpected: 'chá', pinyinSpoken: 'cha', initial: 'good', final: 'ok', tone: 'bad' },
        ],
        review: {
            teacherScore: 85,
            comment: 'So polite! Your measure words were spot on — just stretch the rising tone on 茶 a little longer. 加油！',
            reviewedOn: 'Today, 8:05 AM',
        },
    },
    {
        id: 'fb-bill',
        lessonName: 'Lesson 4: Ordering at a Restaurant',
        exerciseLabel: 'Independent exit check',
        submitted: 'Today, 10:42 AM',
        promptEnglish: 'Ask for the bill and thank the server.',
        sentenceHanzi: '请给我账单，谢谢。',
        sentencePinyin: 'Qǐng gěi wǒ zhàngdān, xièxie.',
        aiScore: 62,
        aiFeedback: 'Good sentence structure. 账单 was difficult to distinguish in the recording.',
        grades: [
            { character: '请', pinyinExpected: 'qǐng', pinyinSpoken: 'qǐng', initial: 'good', final: 'good', tone: 'good' },
            { character: '给', pinyinExpected: 'gěi', pinyinSpoken: 'gěi', initial: 'good', final: 'good', tone: 'good' },
            { character: '我', pinyinExpected: 'wǒ', pinyinSpoken: 'wǒ', initial: 'good', final: 'good', tone: 'good' },
            { character: '账', pinyinExpected: 'zhàng', pinyinSpoken: '—', initial: 'bad', final: 'bad', tone: 'bad', alignment: 'silence' },
            { character: '单', pinyinExpected: 'dān', pinyinSpoken: 'dan', initial: 'ok', final: 'bad', tone: 'bad' },
            { character: '-', pinyinExpected: '-', pinyinSpoken: 'le', initial: 'bad', final: 'bad', tone: 'bad', alignment: 'extra' },
            { character: '谢', pinyinExpected: 'xiè', pinyinSpoken: 'xie', initial: 'good', final: 'good', tone: 'ok' },
            { character: '谢', pinyinExpected: 'xie', pinyinSpoken: 'xie', initial: 'good', final: 'good', tone: 'good' },
        ],
    },
];

export function getLatestReviewedAttempt(): SpeakingAttemptFeedback | null {
    return mockFeedbackAttempts.find(attempt => attempt.review != null) ?? null;
}
